function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16 8.99v11.36c0 1.45-1.04 2.06-2.31 1.36l-3.93-2.19c-.42-.23-1.1-.23-1.52 0l-3.93 2.19c-1.27.7-2.31.09-2.31-1.36V8.99c0-1.71 1.4-3.11 3.11-3.11h7.78c1.71 0 3.11 1.4 3.11 3.11z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.06 12l.88-.88c.29-.29.29-.77 0-1.06a.754.754 0 00-1.06 0l-.88.88-.88-.88a.754.754 0 00-1.06 0c-.29.29-.29.77 0 1.06l.88.88-.88.88c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l.88-.88.88.88c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-.88-.88zM22 5.11v11.36c0 1.45-1.04 2.06-2.31 1.36L16 15.77V8.99c0-1.71-1.4-3.11-3.11-3.11H8v-.77C8 3.4 9.4 2 11.11 2h7.78C20.6 2 22 3.4 22 5.11z"
})));